import places from '../../api/places'

export default {
    namespaced: true,
    state: () => ({
        loading: false,
        items: []
    }),
    getters: {},
    actions: {
        getPlaces ({ commit }, data) {
            commit('setLoading', true)
            return places.getPlaces(data).then((response) => {
                commit('setItems', response)
                commit('setLoading', false)
            })
        },
        clearPlaces ({ commit }){
            commit('setItems', [])
        }
    },
    mutations: {
        setLoading (state, bool) {
            state.loading = bool
        },
        setItems (state, data) {
            state.items = data
        }
    }
}
